import type { ReactNode } from 'react';
import { cn } from '@/lib/ui-kit/utils';

interface CardFooterProps {
  text: string;
  /** The button on the right. */
  action: ReactNode;
  className?: string;
}

/** A divider, a one-line pitch and its button, pinned to the card's bottom edge. */
export function CardFooter({ text, action, className }: CardFooterProps) {
  return (
    <div
      className={cn(
        'relative mt-auto flex items-center gap-2 border-t border-white/10 pt-2.5',
        className,
      )}
    >
      <p className="min-w-0 flex-1 text-[13px] leading-4 tracking-[-0.13px] text-v2-text-primary">
        {text}
      </p>
      {action}
    </div>
  );
}
